export enum BuilderFeatures {
  DIMENSIONS = "dimensions",
  FEATURES = "features",
  INCLUSIONS = "inclusions",
}
